module.exports = "<div id=\"map\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/map-box/map-box.component.html
// module id = ./src/app/map-box/map-box.component.html
// module chunks = main